/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import * as actionTypes from './actionTypes';

const serverTimezoneDate = (date) => {
  return moment(
    new Date(
      new Date(date).toLocaleString('en-US', {
        timeZone: process.env.REACT_APP_TIMEZONE,
      })
    )
  ).format('MM-DD-YYYY');
};

const initilaState = {
  selectedClient: 'PQM',
  invoiceNumber: '',
  reqRecordMailingData: {
    defInvoiceSelectModeCd: 'PQM',
    rebateProgramCd: '',
    planType: 'FD',
    forAllMfg: true,
    qtr: null,
    mfgIdList: null,
    // userId: localStorage.getItem('logInUser') || 'MASTERUSER',
    runProcedure: '',
    mailingDate: serverTimezoneDate(new Date()),
    invoiceNum: '',
  },
  errorMessages: [],
};

const reducer = (state = initilaState, action) => {
  switch (action.type) {
    case 'SET_SELECTED_CLIENT': {
      return { ...state, selectedClient: action.payload };
    }
    case 'SET_INVOICE_NUMBER': {
      return { ...state, invoiceNumber: action.payload };
    }

    case actionTypes.SET_REQ_RECORD_MAILING_DATA: {
      return { ...state, reqRecordMailingData: action.payload };
    }
    case actionTypes.GET_MANUFACTURERS_BY_PQR: {
      return { ...state, manufacturersByPQR: action.payload };
    }
    case actionTypes.RECORD_MAILING_DATE: {
      return { ...state, recordMailingData: action.payload };
    }
    case actionTypes.SET_DEFAULT_QTR: {
      return { ...state, defaultQtrRMD: action.defaultQtrRMD };
    }
    case actionTypes.SET_ERROR_MESSAGES_REC_M_D: {
      return { ...state, errorMessages: action.payload };
    }
    case actionTypes.RESET_RECORD_MAILING_DATE_STORE_REC_M_D: {
      return { ...initilaState };
    }

    default:
      return state;
  }
};

export default reducer;
